import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';

import Button from 'components/Button';
import editIcon from '../../../assets/icons/edit';

import { formatPrice } from '../../util';

import './order-product-item';

export default class OrderProductItem extends Component {

  total () {
    return (this.props.price * this.props.studentCount) - this.props.discount;
  }

	render () {
		return (
			<div className="order-product-item">
        <div className="flex-grid baseline">
          <div className="col-6">
            <h4 className="product-title">{this.props.name}
              <Button
              buttonClass="secondary small square"
              icon={editIcon}
              onClick={this.props.showProductOptions}
              />
            </h4>
            <div className="cost-info">{formatPrice(this.props.price)} per Student</div>
          </div>
          <div className="col-3">
            <div className="qty">{this.props.studentCount} Students</div>
          </div>
          {/*
            TODO: Add Discount
            <div className="col-3">
              <div className="discount">{this.props.discount}</div>
            </div>
          */}
          <div className="col-3 align-right">
            <div className="total-cost">{formatPrice(this.props.total)}</div>
          </div>
        </div>
        <div className="product-desc small light">
          <p>{this.props.description}</p>
        </div>
      </div>
		);
	}
}


// WEBPACK FOOTER //
// ./js/components/OrderProductItem/OrderProductItem.js